import { ActivityList, type ActivityItem } from './primitives/ActivityList'
import { AdminCard } from './primitives'
import { Skeleton } from '@/components/ui/skeleton'

export interface ActivityFeedProps {
  items: ActivityItem[]
  isLoading?: boolean
  emptyMessage?: string
  title?: string
}

export function ActivityFeed({
  items,
  isLoading = false,
  emptyMessage = 'No recent activity',
  title = 'Recent Activity',
}: ActivityFeedProps) {
  return (
    <AdminCard title={title} accentColor="info">
      {isLoading ? (
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-16" />
          ))}
        </div>
      ) : (
        <ActivityList items={items} emptyMessage={emptyMessage} />
      )}
    </AdminCard>
  )
}

